import { useApiQuery } from './useApiQuery';
import { queryKeys } from './queryKeys';
import {
  agentAuthService,
  type AgentConsentContext,
  type AgentConsentParams,
} from '@/services/agentAuthService';

/**
 * Fetches the consent context for the agent authorize page. The consent token it
 * returns is one-time, so the result is never cached or retried.
 */
export const useAgentConsentContext = (params: AgentConsentParams) =>
  useApiQuery<AgentConsentContext>(
    queryKeys.agentAuth.consentContext(params),
    () => agentAuthService.getConsentContext(params),
    { retry: false, staleTime: 0, gcTime: 0 }
  );
